import { MappedClass, MappedProperty, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterAmountExchangeTypeApplicable } from './z-printer-amount-exhange-type-applicable';
import { ZPrinterBooleanApplicable } from './z-printer-boolean-applicable';
import { ZPrinterPaymentTypeApplicable } from './z-printer-payment-type-applicable';
import { ZPrinterStringApplicable } from './z-printer-string-applicable';

@MappedClass()
export class ZPrinterFiscalConfigPayment {
  @MappedProperty()
  index: number;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  name: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  change: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  drawer: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterPaymentTypeApplicable)
  type: ZPrinterPaymentTypeApplicable;

  @MappedPropertyClass(() => ZPrinterAmountExchangeTypeApplicable)
  amount_exchange_type: ZPrinterAmountExchangeTypeApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  amount_required: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  pay_discount: ZPrinterBooleanApplicable;

  @MappedProperty()
  rch_credit_type: number;
}
